/**
 * Convert a Date object to day of year (1-365/366)
 */
export const getDayOfYear = (date: Date): number => {
  const start = new Date(date.getFullYear(), 0, 0);
  const diff = date.getTime() - start.getTime();
  const oneDay = 1000 * 60 * 60 * 24;
  return Math.floor(diff / oneDay);
};

/**
 * Convert day of year back to a Date object
 */
export const getDateFromDayOfYear = (dayOfYear: number, year: number = new Date().getFullYear()): Date => {
  const start = new Date(year, 0, 0);
  const targetDate = new Date(start.getTime() + (dayOfYear * 24 * 60 * 60 * 1000));
  return targetDate;
};

/**
 * Get the next day of year, wrapping around to 1 if at the end
 */
export const getNextDayOfYear = (currentDay: number, totalDays: number = 365): number => {
  return currentDay >= totalDays ? 1 : currentDay + 1;
};

/**
 * Get the previous day of year, wrapping around to totalDays if at the beginning
 */
export const getPreviousDayOfYear = (currentDay: number, totalDays: number = 365): number => {
  return currentDay <= 1 ? totalDays : currentDay - 1;
};

/**
 * Format a day of year as a readable date string
 */
export const formatDayOfYearAsDate = (dayOfYear: number, year: number = new Date().getFullYear()): string => {
  const date = getDateFromDayOfYear(dayOfYear, year);
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  return `${months[date.getMonth()]} ${date.getDate()}`;
};
